/**
 * Open incognito tab — toolbar button that opens a new incognito window
 *
 * Declares a single web-accessible-resource, images/48x48.png, matched to every origin
 * with no dynamic URL. That one icon is served at a fixed URL from any page whenever the
 * extension is installed, so a single image load is conclusive.
 *
 * Manifest verified against version 2.6.6.
 */

import { probeImage } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'ebgmlfdcgihhfheckfdmhnmedjigogmm';

export const openIncognitoTab: ExtensionDefinition = {
  id: ID,
  name: 'Open incognito tab',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 100_000,
  notes:
    'A single static WAR (images/48x48.png) exposed to every origin with no dynamic URL. ' +
    'One image load is conclusive.',
  signals: [
    {
      id: 'war-icon-48',
      kind: 'web-accessible-resource',
      description:
        'Load images/48x48.png via <img> — the extension icon, its only web-accessible ' +
        'resource, exposed to every origin and readable without a CORS grant.',
      weight: 1,
      run: () => probeImage(ID, 'images/48x48.png'),
    },
  ],
};
